<div class="bottom-banner">
    <div class="banner-content">
        <div class="banner-text-title">
            Connect Now to See Your Campaign Data
        </div>
        <div>
            <img [src]="'svg/arrow-vector-green.svg' | assetVersion">
            <img [src]="'svg/arrow-vector-green.svg' | assetVersion">
        </div>
        <div class="banner-text">
            Access your own in-depth campaign analysis to optimize your ad strategy.
        </div>
        <div>
            <img [src]="'svg/arrow-vector-purple.svg' | assetVersion">
            <img [src]="'svg/arrow-vector-purple.svg' | assetVersion">
        </div>
        <div class="banner-button">
            <button (click)="onClick()">Connect Now</button>
        </div>
    </div>
</div>